import { render, staticRenderFns } from "./LotPriorityBadge.vue?vue&type=template&id=4f500e1e"
import script from "./LotPriorityBadge.vue?vue&type=script&lang=js"
export * from "./LotPriorityBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports